// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-sect {
    margin-top: 25px;
}

.custom-container {
    padding-left: 0%;
    padding-right: 0%;
}

.main-box {
    padding: 30px;
    border-radius: 16px;
    background-color: #ffff;
    position: relative;
    margin: 20px 0;
}

@media (max-width: 768px) {
    .custom-container {
        padding-left: 4%;
        padding-right: 4%;
    }
}

@media (max-width: 991px) {
    .main-box {
        padding: 12px;
    }
}

.custom-row .row {
    padding-top: 15px;
    padding-bottom: 15px;
    /*background-color: #FFF;*/
    /*box-shadow: 0 0 10px 0 #dad8d8;*/
    /*margin-bottom: 30px;*/
}

.custom-row .row:hover {
    background-color: #f8f9fa;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
    /*border-radius: 10px;*/
}

.heading {
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 30px;
}

.user-profile {
    width: 70px;
    height: 70px;
    border-radius: 13px;
    object-fit: cover;
}

.notification-link {
    color: #6c2fbb !important;
    text-decoration: none;
    /* font-size: 12px; */
    /* font-weight: 600; */
}

.img-box {
    display: flex;
    justify-content: center;
    height: 200px;
    position: relative;
    overflow: hidden;
    background: #f8f9fa;
    border-radius: 16px;
    width: 100%;
}

.img-box img {
    height: 100%;
    object-fit: cover;
    cursor: pointer;
}

.FF-scroll-modify {
    height: 700px !important;
    overflow-x: hidden;
    overflow-y: scroll;
    margin-top: 10px;
}  

@media (max-width: 1600px) {
    .img-box {
        height: 185px
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/notifications/notifications.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,0BAA0B;IAC1B,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;IACxC,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI;IACJ;AACJ","sourcesContent":[".notification-sect {\r\n    margin-top: 25px;\r\n}\r\n\r\n.custom-container {\r\n    padding-left: 0%;\r\n    padding-right: 0%;\r\n}\r\n\r\n.main-box {\r\n    padding: 30px;\r\n    border-radius: 16px;\r\n    background-color: #ffff;\r\n    position: relative;\r\n    margin: 20px 0;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .custom-container {\r\n        padding-left: 4%;\r\n        padding-right: 4%;\r\n    }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .main-box {\r\n        padding: 12px;\r\n    }\r\n}\r\n\r\n.custom-row .row {\r\n    padding-top: 15px;\r\n    padding-bottom: 15px;\r\n    /*background-color: #FFF;*/\r\n    /*box-shadow: 0 0 10px 0 #dad8d8;*/\r\n    /*margin-bottom: 30px;*/\r\n}\r\n\r\n.custom-row .row:hover {\r\n    background-color: #f8f9fa;\r\n    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);\r\n    /*border-radius: 10px;*/\r\n}\r\n\r\n.heading {\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.user-profile {\r\n    width: 70px;\r\n    height: 70px;\r\n    border-radius: 13px;\r\n    object-fit: cover;\r\n}\r\n\r\n.notification-link {\r\n    color: #6c2fbb !important;\r\n    text-decoration: none;\r\n    /* font-size: 12px; */\r\n    /* font-weight: 600; */\r\n}\r\n\r\n.img-box {\r\n    display: flex;\r\n    justify-content: center;\r\n    height: 200px;\r\n    position: relative;\r\n    overflow: hidden;\r\n    background: #f8f9fa;\r\n    border-radius: 16px;\r\n    width: 100%;\r\n}\r\n\r\n.img-box img {\r\n    height: 100%;\r\n    object-fit: cover;\r\n    cursor: pointer;\r\n}\r\n\r\n.FF-scroll-modify {\r\n    height: 700px !important;\r\n    overflow-x: hidden;\r\n    overflow-y: scroll;\r\n    margin-top: 10px;\r\n}  \r\n\r\n@media (max-width: 1600px) {\r\n    .img-box {\r\n        height: 185px\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
